import { render, staticRenderFns } from "./InformacaoProposta.vue?vue&type=template&id=1cd247ab&"
import script from "./InformacaoProposta.vue?vue&type=script&lang=js&"
export * from "./InformacaoProposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports